/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Mcp_SubInputs */

const en_vc_mcp_sub = /** @type {(inputs: Vc_Mcp_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every menu item, tool gesture, panel and dialog can be driven over a JSON control channel and a built-in MCP server. Claude and other AI agents can draw, edit and export in VectorCraft the way a person does.`)
};

const zh_vc_mcp_sub = /** @type {(inputs: Vc_Mcp_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个菜单项、工具手势、面板和对话框，都可以通过 JSON 控制通道和内置的 MCP server 来驱动。Claude 等 AI 助手可以像人一样在 VectorCraft 里绘图、编辑和导出。`)
};

/**
* | output |
* | --- |
* | "Every menu item, tool gesture, panel and dialog can be driven over a JSON control channel and a built-in MCP server. Claude and other AI agents can draw, edi..." |
*
* @param {Vc_Mcp_SubInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_mcp_sub = /** @type {((inputs?: Vc_Mcp_SubInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Mcp_SubInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_mcp_sub(inputs)
	return zh_vc_mcp_sub(inputs)
});
export { vc_mcp_sub as "vc.mcp.sub" }